import React, { useContext, useEffect, useState } from "react";
// another components
// styled components
import { Col, Row, Image, Button} from "antd";
// models
import { PostulacionModel } from "../../../../../models/PostulacionesModel/postulacion.model";
import EscudoAlcaldiaBlanco from "../../../../../assets/landing/medellin.png";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

interface IProps {
  postulacion: any;
  lineasConvocatoria: any;
}

export const FormularioInscripcion: React.FC<IProps> = (props: IProps) => {
  const imprimir = () => {
    const modalContent = document.getElementById('modal_custom');
    if (modalContent) {
        html2canvas(modalContent).then(canvas => {
            const radicado = props.postulacion.radicado;
            const pdf = new jsPDF('p', 'mm', 'a4');
            const pageWidth = 210;
            const pageHeight = 297;
            const margin = 5; // Margen en mm

            const canvasWidth = canvas.width;
            const canvasHeight = canvas.height;

            const imgWidth = pageWidth - 2 * margin;
            const imgHeight = (canvasHeight * imgWidth) / canvasWidth;

            const footerElement = modalContent.querySelector('#footer');
            let footerPosition = canvasHeight;

            if (footerElement) {
                const rect = footerElement.getBoundingClientRect();
                const modalRect = modalContent.getBoundingClientRect();
                footerPosition = rect.top - modalRect.top;
            }

            const pageCanvas = document.createElement('canvas');
            const pageContext = pageCanvas.getContext('2d');
            pageCanvas.width = canvasWidth;
            pageCanvas.height = footerPosition;

            pageContext.drawImage(canvas, 0, 0, canvasWidth, footerPosition, 0, 0, canvasWidth, footerPosition);

            const pageData = pageCanvas.toDataURL('image/png');
            const pageImgHeight = (footerPosition * imgWidth) / canvasWidth;

            pdf.addImage(pageData, 'PNG', margin, margin, imgWidth, pageImgHeight);
            pdf.save(radicado);
        });
    }
  };

  return (
    <>
      <div
        id="modal_custom"
        className="row"
        style={{
          paddingRight: "16px",
          paddingLeft: "16px",
          paddingTop: "16px",
          paddingBottom: "16px",
        }}
      >
        <div className="container-fluid border bg-light p-4">
          <div className="row">
            <Image src={EscudoAlcaldiaBlanco} style={{ maxWidth: "20%"}} preview={false} />
            <br />
            <br />
            <span className="md-title-text text-center font-size-16px">
              <br />
              SECRETARÍA DE CULTURA CIUDADANA
            </span>
            <br />
            <span className="md-title-text text-center font-size-16px">
              CONVOCATORIA DE FOMENTO Y ESTÍMULOS PARA EL ARTE Y LA CULTURA
            </span>
          </div>
        </div>
        <div className="row">
          <br />
        </div>
        <div className="row" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <div
            className="col-4 font-size-14px font-family-Montserrat-SemiBold"
            style={{ paddingLeft: "16px" }}
          >
            Código:
          </div>
          <div className="col-6 font-size-14px font-family-Montserrat-Regular">
            {props.postulacion.radicado}
          </div>
        </div>
        <div className="row" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <div
            className="col-4 font-size-14px font-family-Montserrat-SemiBold"
            style={{ paddingLeft: "16px" }}
          >
            Nombre de la propuesta:
          </div>
          <div className="col-6 font-size-14px font-family-Montserrat-Regular">
            {props.postulacion.nombre_propuesta}
          </div>
        </div>
        <div className="row" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <div
            className="col-4 font-size-14px font-family-Montserrat-SemiBold"
            style={{ paddingLeft: "16px" }}
          >
            Línea convocatoria:
          </div>
          <div className="col-6 font-size-14px font-family-Montserrat-Regular">
            {props.postulacion.linea_convocatoria}
          </div>
        </div>
        <div className="row" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <div
            className="col-4 font-size-14px font-family-Montserrat-SemiBold"
            style={{ paddingLeft: "16px" }}
          >
            Categoría:
          </div>
          <div className="col-6 font-size-14px font-family-Montserrat-Regular">
            {props.postulacion.categoria_linea_convocatoria}
          </div>
        </div>
        <div className="row" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <div
            className="col-4 font-size-14px font-family-Montserrat-SemiBold"
            style={{ paddingLeft: "16px" }}
          >
            Tipo de participante:
          </div>
          <div className="col-6 font-size-14px font-family-Montserrat-Regular">
            {props.postulacion.tipo_participante == '3' ? 'Grupo Conformado' : ''}
            {props.postulacion.tipo_participante == '2' ? 'Persona Jurídica' : ''}
            {props.postulacion.tipo_participante == '1' ? 'Persona Natural' : ''}
          </div>
        </div>
        <hr />
        <div className="row" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <div
            className="col-4 font-size-14px font-family-Montserrat-SemiBold"
            style={{ paddingLeft: "16px" }}
          >
            Nombre del participante / representante:
          </div>
          <div className="col-6 font-size-14px font-family-Montserrat-Regular">
            {props.postulacion.nombre_participante ? props.postulacion.nombre_participante : props.postulacion.nombre_representante }
          </div>
        </div>
        <div className="row" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <div
            className="col-4 font-size-14px font-family-Montserrat-SemiBold"
            style={{ paddingLeft: "16px" }}
          >
            Documento identificación:
          </div>
          <div className="col-6 font-size-14px font-family-Montserrat-Regular">
            {props.postulacion.numero_documento_participante}
          </div>
        </div>
        <div id="footer"></div>
        <div className="col-2 text-center">
          <Button className="form_bg_btn button-blanco-radius" onClick={imprimir}>
              Descargar
          </Button>
        </div>
      </div>
    </>
  );
};
